<div [ngClass]="isDesktop === true ? 'margin' : 'margin scroll-table'">
  <p-table
    #dt
    selectionMode="single"
    [columns]="listColumns"
    [value]="resultDisplay"
    [rows]="nbRow"
    [paginator]="false"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    (onRowSelect)="onRowSelect($event)"
    >
    <ng-template pTemplate="caption">
      <span class="header-grid-wrapper">
        <span class="align-right font-bold">{{'Bsk_Load' | translate}}</span>
      </span>
    </ng-template>
    <ng-template let-columns pTemplate="header">
      <tr>
        <th class="width-col-3"></th>
        <th class="width-col-3"></th>
        <th [pSortableColumn]="columns[1].field" class="width-auto">
          <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{ columns[1].header }}
        </th>
        <th [pSortableColumn]="columns[2].field" class="width-col-count">
          <p-sortIcon [field]="columns[2].field"></p-sortIcon>{{ columns[2].header }}
        </th>
      </tr>
    </ng-template>
    <ng-template let-rowData let-rowIndex="rowIndex" let-columns="columns" pTemplate="body">
      <tr [pSelectableRow]="rowData" class="table-row colorbox-bsk"
        [className]="'class' + rowData.color"
        >
        <td class="width-auto">
          <img src="{{ rowData[columns[0].field] }}" width="35" (error)="updateUrl(rowData)" />
        </td>
        <td>
          <div class="basket-info">
            <i class="pi pi-question-circle md-24" pTooltip="{{ rowData.name }}" tooltipPosition="top">
            </i>
            @if (rowData.description !== '') {
              <i
                class="pi pi-info-circle md-24"
                pTooltip="{{ rowData.description }}"
                tooltipPosition="top"
                >
              </i>
            }
          </div>
        </td>
        <td class="width-auto">
          <div>
            {{ rowData[columns[1].field] }}
          </div>
        </td>
        <td class="align-right">
          <div>
            {{ rowData[columns[2].field] }}
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td>{{'Empty_1' | translate}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

